


import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import Checkbox from '@/components/Checkbox/index.vue';

@Component({
  components: {
    Checkbox
  }
})
export default class SubmitArea extends Vue {
  @Prop() private privacyApproved!: boolean;

  @Emit('submit')
  private submitClicked() {
    return;
  }

  @Emit('checkbox-input')
  private handleInput() {
    return;
  }
}
